import { Config, Data, Render as PuckRender } from '@measured/puck';
import { ExtendedRootFieldProps } from '../../interface/pageInterface';

type Props = {
  data: Data;
  config: Config;
};

export type ThemeColor = {
  r: number;
  g: number;
  b: number;
};
export function Render({ data, config }: Props) {
  const page = document.getElementsByClassName(
    'puck-pages-wrapper',
  )[0] as HTMLDivElement;
  const color = (data?.root?.props as ExtendedRootFieldProps)
    ?.themeColor as ThemeColor;
  const backgroundColor = (data?.root?.props as ExtendedRootFieldProps)
    ?.backgroundColor as ThemeColor;

  if (page) {
    page.setAttribute('role', 'main');
  }
  if (page && color) {
    page.style.setProperty(
      '--color-page-builder-theme',
      `${color?.r} ${color?.g} ${color?.b}`,
    );
    if (backgroundColor) {
      page.style.setProperty(
        '--template-background-color',
        `${backgroundColor}`,
      );
    }
  }
  const tab = (data?.root?.props as ExtendedRootFieldProps)?.tab;
  if (tab) {
    if (tab?.title) {
      document.title = tab.title;
    }
    if (tab?.favicon?.imageUrl) {
      const link = document.getElementById('favicon') as HTMLLinkElement;
      link.rel = 'icon';
      link.href = process.env.REACT_APP_S3_BUCKET_URL + tab?.favicon?.imageUrl;
    }
  }

  return <PuckRender config={config} data={data} />;
}
